import { cn } from '@workspace/ui/lib/utils'
import { TrendingUp } from 'lucide-react'
import type { EvalImprovement } from '../types'

export interface EvaluationImprovementsProps {
  improvements: EvalImprovement[]
}

export function EvaluationImprovements({ improvements }: EvaluationImprovementsProps) {
  return (
    <div className="mt-4 rounded-xl border border-border bg-card/30 px-6 py-4">
      <div className="mb-3 flex items-center gap-2">
        <TrendingUp className="size-3.5 text-emerald-400" />
        <p className="text-[10px] font-semibold uppercase tracking-widest text-muted-foreground/80">
          Changes since last evaluation
        </p>
      </div>
      <ul className="space-y-2.5">
        {improvements.map((item) => (
          <li key={item.text} className="flex items-start gap-2.5">
            <span
              className={cn(
                'mt-1 size-1.5 shrink-0 rounded-full',
                item.type === 'improved' && 'bg-emerald-400',
                item.type === 'regressed' && 'bg-red-400',
                item.type === 'unchanged' && 'bg-muted-foreground/30'
              )}
            />
            <span className="text-sm leading-relaxed text-muted-foreground">{item.text}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
